// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { SHAREPOINT_WORKBOOK_CONTRACT_VERSION_V2 } from 'constants/SharepointWorkbookContract';
import type { SharepointWorkbookRowsResponse } from 'pages/QuoteView/LoadBuilding/sharepoint/types/SharepointWorkbookRows';
import type { Maybe } from 'types/UtilityTypes';

export type GetSharepointWorkbookRowsParams = {
  url: string;
  worksheet?: string;
};

type SharepointWorkbookRowsApiResponse = Omit<
  SharepointWorkbookRowsResponse,
  'suggestions'
> & {
  suggestions?: Maybe<SharepointWorkbookRowsResponse['suggestions']>;
};

/**
 * Fetches backend-produced workbook suggestions via Microsoft Graph. Uses POST so the
 * SharePoint sharing URL (capability token) is not sent as a GET query string.
 */
export async function getSharepointWorkbookRows(
  params: GetSharepointWorkbookRowsParams
): Promise<SharepointWorkbookRowsResponse> {
  const { data } = await axios.post<SharepointWorkbookRowsApiResponse>(
    '/sharepoint/workbooks/load-suggestions',
    {
      contractVersion: SHAREPOINT_WORKBOOK_CONTRACT_VERSION_V2,
      url: params.url,
      ...(params.worksheet ? { worksheet: params.worksheet } : {}),
    }
  );

  return {
    ...data,
    suggestions: Array.isArray(data.suggestions) ? data.suggestions : [],
  };
}
